module.exports = __webpack_public_path__ + "static/media/1018001BE.67384587.jpg";